<div class="toast-container">
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="toast"
      [class.closing]="toast.state === 'closing'"
      [class.clickable]="!!toast.action"
      [style.--duration.ms]="toast.duration"
      [style.--theme-color]="getToastColor(toast)"
      (click)="handleToastClick(toast)"
    >
      <!-- Icono (según tipo) -->
      <div class="toast-icon">
        @switch (toast.type) {
          @case ('success') {
            <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
          }
          @case ('error') {
            <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          }
          @case ('warning') {
            <svg viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
          }
          @case ('info') {
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
          }
          @default {
            <!-- Custom o Default usa Info -->
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
          }
        }
      </div>

      <div class="toast-content">
        <!-- Renderizado de Template Personalizado -->
        @if (toast.template) {
          <ng-container *ngTemplateOutlet="toast.template; context: toast.templateContext"></ng-container>
        } @else {
          <!-- Renderizado Standard -->
          @if (toast.title) {
            <div class="toast-title">{{ toast.title }}</div>
          }
          @if (toast.message) {
            <div class="toast-message">{{ toast.message }}</div>
          }
        }
      </div>

      <!-- Botón cerrar (siempre visible para tener control) -->
      <button
        class="toast-close"
        (click)="closeToast($event, toast.id)"
        aria-label="Cerrar"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <!-- Barra de progreso -->
       @if (toast.duration && toast.duration > 0) {
        <div class="toast-progress"></div>
       }
    </div>
  }
</div>
